import { useContext } from 'react';
import { cn } from '@savvy-kit/lib/utils';

import { DataTableContext } from '../data-table-context';

/** Put on the row that owns the checkbox — hovering it is what reveals the checkbox. */
export const BULK_SELECT_ROW_GROUP = 'group/bulk-select';

type BulkSelectRevealProps = React.ComponentProps<'div'> & {
  /** Pin visible regardless of hover — e.g. this row is selected. */
  readonly visible?: boolean;
};

export function BulkSelectReveal({ visible = false, className, ...props }: BulkSelectRevealProps) {
  // Bare `useContext`, not `useDataTableContext`: consumers render their own select cells
  // (the tasks table's group rows) outside a DataTable, including in unit tests, and the
  // hook throws without a provider.
  const context = useContext(DataTableContext);
  const pinned = visible || context?.anySelected === true;

  return (
    <div
      className={cn(
        'flex items-center transition-opacity',
        // `focus-within` keeps the checkbox reachable by keyboard while invisible, and
        // `hover:none` covers touch devices where Tailwind's `hover:` never fires.
        'group-hover/bulk-select:opacity-100 focus-within:opacity-100 [@media(hover:none)]:opacity-100',
        pinned ? 'opacity-100' : 'opacity-0',
        className,
      )}
      {...props}
    />
  );
}
